import { isFunction, mapValues } from '@sama/micro-dash';
import {
  EventTrackingOptions,
  EventTrackingValue,
} from '../../team-apis/core/event-tracking';
import { Tracker, TrackingEvent } from './event-utils';

/**
 * This class is the basic building block for hierarchical trackers, where each
 * level in the hierarchy adds context to an event before it is sent to DataDen.
 */
export abstract class AbstractTrackerWithContext implements Tracker {
  protected context: EventTrackingValue = {};

  protected constructor(
    // public so it can be stubbed in tests
    public parentTracker: Tracker,
  ) {}

  addContext(context: EventTrackingValue) {
    Object.assign(this.context, context);
  }

  track(event: TrackingEvent, options?: EventTrackingOptions) {
    this.trackWithoutContext(this.mergeContext(event), options);
  }

  protected mergeContext(value: TrackingEvent): TrackingEvent {
    // fix me if you change this code
    // eslint-disable-next-line no-param-reassign -- fix me!
    value = { ...this.context, ...value };
    if (this.parentTracker instanceof AbstractTrackerWithContext) {
      // fix me if you change this code
      // eslint-disable-next-line no-param-reassign -- fix me!
      value = this.parentTracker.mergeContext(value);
    }
    return deepEvaluate(value);
  }

  protected trackWithoutContext(
    event: TrackingEvent,
    options?: EventTrackingOptions,
  ) {
    if (this.parentTracker instanceof AbstractTrackerWithContext) {
      this.parentTracker.trackWithoutContext(event, options);
    } else {
      this.parentTracker.track(event, options);
    }
  }
}

function deepEvaluate(value: any): any {
  if (isFunction(value)) {
    return value();
  } else if (Array.isArray(value)) {
    return value.map(deepEvaluate);
  } else if (value instanceof Object) {
    return mapValues(value, deepEvaluate);
  } else {
    return value;
  }
}
